import { create } from 'zustand'

interface IListCreated {
  success: boolean
  id?: string
  name?: string
}
export interface ModalCreateListState {
  isLoading: boolean
  isOpen: boolean
  nameNewList: string
  listCreated: IListCreated
  listIdToEdit?: string | null
  onClose: () => void
  setListCreated: (listCreated: IListCreated) => void
  setIsLoading: (isLoading: boolean) => void
  setIsOpen: (isOpen: boolean) => void
  setNameNewList: (nameNewList: string) => void
  setListIdToEdit: (listIdToEdit: string) => void
}

const initialState = {
  listCreated: {
    success: false
  },
  isLoading: false,
  isOpen: false,
  nameNewList: '',
  listIdToEdit: null
}

export const useModalCreateListStore = create<ModalCreateListState>()(
  (set) => ({
    ...initialState,
    onClose: () => set({ ...initialState }),
    setListCreated: (listCreated) => set({ listCreated }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setIsOpen: (isOpen) => set({ isOpen }),
    setNameNewList: (nameNewList) => set({ nameNewList }),
    setListIdToEdit: (listIdToEdit) => set({ listIdToEdit })
  })
)
